/**
 * @callback eventCallback
 */

/**
 *
 * @param {string} event
 * @param {eventCallback} cb
 * @param {string} el
 * @param {string} elSecondary
 * @return {jQuery}
 */
export const on = (event, cb, el, elSecondary = null, payload = null) => {
  return $(el ? el : window).on(`${event}.mmfg`, elSecondary, payload, (e, data) => {
    cb({event: e, payload: data});
  });
};

export const on2 = (event, cb, el, elSecondary = null, payload = null) => {
  console.log(`${event}.mmfg`);
  // event element
  let elEvent = (el !== null) ? el : document;
  // event name
  let eventName = event+'.mmfg';

  elEvent.addEventListener(eventName, function (e) {
    cb({event: e, payload: e.payload});
  });

  // return $(el ? el : window).on(`${event}.mmfg`, elSecondary, payload, (e, data) => {
  //   cb({event: e, payload: data});
  // });
};


/**
 *
 * @param {string} event
 * @param {object} payload
 * @param {string} el
 * @return {jQuery}
 */
export const emit = (event, payload, el) => {
  return $(el ? el : window).trigger(`${event}.mmfg`, payload);
};

export const emit2 = (event, payload, el) => {
  // event element
  let elEvent = (el !== null) ? el : document;
  // event name
  let eventName = event+'.mmfg';
  // launch event
  elEvent.dispatchEvent(new Event(eventName,payload));
};

/**
 *
 * @param {string} event
 * @param {eventCallback} cb
 * @param {string} el
 * @return {jQuery}
 */
export const one = (event, cb, el) => {
  return $(el ? el : window).one(event, (e, data) => {
    cb({event: e, payload: data});
  });
};

/**
 *
 * @param {string} event
 * @param {string} el
 * @return {jQuery}
 */
export const off = (event, el) => {
  return $(el).off(`${event}.mmfg`);
};
